<template>
  <router-view
    :programs="programs"
    @created="listPrograms"
  ></router-view>
</template>
<script>
export default {
  name: "ProgramRoot",
  data() {
    return {
      programs: [],
      isLoading: false
    }
  },
  created() {
    this.bootstrap()
  },
  methods: {
    async bootstrap() {
      await this.listPrograms()
    },
    async listPrograms() {
      return await this.$store.dispatch("program/list", {
        company_id: this.$route.params.company_id
      })
      .then((res) => {
        this.programs = res
      })
      .catch((error) => {
         this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
